const configuredBaseUrl = import.meta.env.VITE_AXON_API_BASE_URL;
const API_BASE_URL = (
  configuredBaseUrl || (import.meta.env.DEV ? "http://127.0.0.1:8000" : "https://api.axonleads.ru")
).replace(/\/$/, "");

export class ProfileApiError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = "ProfileApiError";
    Object.assign(this, details);
  }
}

async function profileRequest(idToken, path = "/v1/profile", options = {}) {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      method: options.method || "GET",
      headers: {
        Authorization: `Bearer ${idToken}`,
        ...(options.body ? { "Content-Type": "application/json" } : {}),
      },
      body: options.body ? JSON.stringify(options.body) : undefined,
      cache: "no-store",
      credentials: "omit",
      redirect: "error",
      referrerPolicy: "no-referrer",
    });
  } catch {
    throw new ProfileApiError("Нет связи с AxonLeads. Проверьте интернет и попробуйте ещё раз.");
  }
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    const error = payload?.error || {};
    throw new ProfileApiError(
      typeof error.message === "string" ? error.message : "Не получилось сохранить профиль.",
      {
        status: response.status,
        code: error.code,
        usage: error.usage,
        limit: error.limit,
        resource: error.resource,
        recoveryAction: error.recoveryAction,
      },
    );
  }
  return payload;
}

export function fetchProfile(idToken) {
  return profileRequest(idToken);
}

export function saveProfile(idToken, profile) {
  return profileRequest(idToken, "/v1/profile", { method: "PUT", body: profile });
}

export function activateOnboarding(idToken, profile) {
  return profileRequest(idToken, "/v1/onboarding/activate", {
    method: "POST",
    body: profile,
  });
}
